<template>
  <div>
    <Row>
      <Form ref="queryDictDataForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('system.dict-data.dictSign.label')" prop="dictSign">
            <Input v-model="query.dictSign" :placeholder="$t('system.dict-data.dictSign.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.dict-data.dictValue.label')" prop="dictValue">
            <Input v-model="query.dictValue" :placeholder="$t('system.dict-data.dictValue.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.dict-data.status.label')" prop="status">
        <Select v-model="query.status" clearable filterable :placeholder="$t('system.dict-data.status.holder')">
          <Option v-for="item in $t('system.dict-data.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openDictDataDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="dictDataTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
<!--        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.dictDataTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="dictDataDrawer" :title="this.$t('drawer.title')[dictDataDrawer.type]" :visible.sync="dictDataDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <dictData-form ref="dictDataForm"/>
        <div class="right-drawer__footer" v-if="dictDataDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="dictDataDrawer.submiting">{{ dictDataDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="dictDataDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import DictDataForm from '@/views/system/dict-data/components/Form.vue';
Vue.component('dictData-form', DictDataForm);

export default {
  name: 'aip-system-dictData-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      dictDataDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.system.DictData.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openDictDataDrawer(dictData){
      this.dictDataDrawer.visible = true
      this.dictDataDrawer.type = dictData ? dictData.type : 'add'
      this.$nextTick(()=>{
          if(dictData){
              this.$refs['dictDataForm'].getDictData(dictData.id,dictData.type)
          }else{
            this.$refs['dictDataForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.dictDataDrawer.submiting = true;
        this.$refs.dictDataForm.handleSubmit(
          data=>{
            this.dictDataDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.dictDataDrawer.visible=false, 1000);
          },
          ()=>{
            this.dictDataDrawer.submiting = false;
          }
        )
    },
    deleteDictData(id){
      api.system.DictData.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.system.DictData.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'dictSign', align:'center',minWidth: 150,fixed:'left', title:  this.$t('system.dict-data.dictSign.label')},
          {key: 'dictValue', align:'center',minWidth: 150, title:  this.$t('system.dict-data.dictValue.label')},
          {key: 'dictKey', align:'center',minWidth: 150, title:  this.$t('system.dict-data.dictKey.label')},
          {key: 'styleClass', align:'center',minWidth: 150, title:  this.$t('system.dict-data.styleClass.label')},
          {
            key: 'isDefault',
            align: 'center',
            width: 120,

            column:'isDefault',
            filters: this.$t('system.dict-data.isDefault.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.isDefault = value
              this.handleSearch();
            },
            title: this.$t('system.dict-data.isDefault.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.isDefault==t.value).label}</div>
            }
          },
          {key: 'dictSort', align:'center',minWidth: 100, title:  this.$t('system.dict-data.dictSort.label')},
          {
            key: 'status',
            align: 'center',
            width: 120,

            column:'status',
            filters: this.$t('system.dict-data.status.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.status = value
              this.handleSearch();
            },
            title: this.$t('system.dict-data.status.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.status==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 150, title:  this.$t('system.dict-data.remark.label')},
          {key: 'createTime', align: 'center', width:200, title: this.$t('system.dict-data.createTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 180,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openDictDataDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openDictDataDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteWebSite(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
